import axios from 'axios'

export default {
  async initialize (publication, params) {
    try {
      const response = await axios.post(`/publications/${publication}/ai-prepare`, params)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err, 'response.data', false)
    }
  },
  async execute (publication, params) {
    try {
      const response = await axios.post(`/publications/${publication}/ai-relay`, params)
      console.log('payload: ', params)
      console.log(response)
      if (response.data.status === 'success') {
        return _.get(response, 'data')
      } else {
        console.error(response)
      }
    } catch (err) {
      if (err.response && err.response?.data?.status === 'error') {
        return _.get(err.response, 'data')
      }
      console.error(err)
    }
    return false
  },
  async generate (publication) {
    try {
      const response = await axios.post(`/publications/${publication}/ai-process-outline`)
      console.log(response)
      if (response.data.status === 'success') {
        return _.get(response, 'data')
      } else {
        console.error(response)
      }
    } catch (err) {
      console.error(err)
    }
    return false
  },
  async initializeScreenWithPublication (dataobject, publication, params) {
    try {
      const response = await axios.post(`/data/${dataobject}/${publication}/ai-prepare-screen`, params)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err.response, 'data', false)
    }
  },
  async initializeScreen (dataobject, params) {
    try {
      const response = await axios.post(`/data/${dataobject}/ai-prepare-screen`, params)
      return _.get(response, 'data.data')
    } catch (err) {
      console.error(err)
      return _.get(err.response, 'data', false)
    }
  },
  async executeScreen (dataobject, params) {
    try {
      console.log('payload: ', params)
      const response = await axios.post(`/data/${dataobject}/ai-relay`, params)
      console.log(response)
      if (response.data.status === 'success') {
        return _.get(response, 'data.data')
      } else {
        return _.get(response, 'data', false)
      }
    } catch (err) {
      console.error(err)
      if (err.response && err.response?.data?.status === 'error') {
        return _.get(err.response, 'data', false)
      }
    }
    return false
  },
  async getMessages (chatSessionGuid) {
    try {
      const response = await axios.get(`/chat-session/${chatSessionGuid}/get-history`)
      console.log(response)
      if (response.data.status === 'success') {
        return _.get(response, 'data.data')
      } else {
        return _.get(response, 'data', false)
      }
    } catch (err) {
      console.error(err)
      if (err.response && err.response?.data?.status === 'error') {
        return _.get(err.response, 'data', false)
      }
    }
    return false
  },
  async removeMessages (chatSession, params) {
    try {
      const response = await axios.delete(`/chat-session/${chatSession}/messages`, { data: params })
      console.log(response)
      if (response.data.status === 'success') {
        return _.get(response, 'data.data')
      } else {
        return _.get(response, 'data', false)
      }
    } catch (err) {
      console.error(err)
      if (err.response && err.response?.data?.status === 'error') {
        return _.get(err.response, 'data', false)
      }
    }
    return false
  },

}